import { observable, computed, action } from "mobx"; //set
import { store } from "../mainStore";
import { setTimeout } from "timers";
import {getDiceFace} from "../../server/HandDetect";

const hands = {
	1: 'high-hand',
	2: 'pair',
	3: 'two-pair',
	4: 'three-of-a-kind',
	5: 'straight',
	6: 'flush',
	7: 'full-house',
	8: 'four-of-a-kind',
	9: 'five-of-a-kind',
	10: 'six-of-a-kind',
	11: 'straight-flush',
	12: 'royal-flush'
};

const dieFaceValue = [7,3,11,5,14,9,14,4,8,20,6,7,5,12,10,2,8,13,12,10,13,4,9,2,14,3,9,6,4,11,2,3,8,6,20,12,12,7,9,13,10,5,11,6,5,14,3,4,13,11,8,10,7,2];

var c = 3; //1;
var d = 2;
var h = 1; //3;
var s = 4;
var w = 0; // wild is all suits

const dieFaceSuit = [s,h,d,d,c,c,h,s,d,w,c,h,h,d,h,d,c,s,h,c,d,c,s,s,s,c,d,s,d,h,c,d,s,h,w,c,s,c,h,c,d,s,s,d,c,d,s,h,h,c,h,s,d,h];

// const ServerStates = {
// 	1: 'STATE_WAITING',
// 	2: 'STATE_PLAYING',
// 	3: 'STATE_COMPLETED'
// };

export class Hand{
	constructor(hand, network){
		var Selection = [];
		var DiceRoll = [];
		var lastRoll = {};

		console.log('HAND constr :: h =', hand)
		if(hand && hand.Rolls?.length){
			lastRoll = hand.Rolls[hand.Rolls.length - 1];
			DiceRoll = lastRoll.DiceRoll;
			Selection = lastRoll.Selection; //hand.Rolls[hand.Rolls.length - 2]
			this.lastCombination = lastRoll.BestHandTarget;
			this.diceFaces = lastRoll.DiceFaces;
		}

		var faces = [];
		dieFaceValue.forEach((value, i) => {
			faces.push([value, dieFaceSuit[i]]);
			if(faces.length === 6){
				this.dice.push({
					faces: faces,
					held: Selection.indexOf(this.dice.length) > -1,
					showing: DiceRoll[this.dice.length],
				})
				faces = [];
			}
		});

		if(!network) { 	Object.assign(this, hand)}

		if(hand && network){
			this.best = lastRoll.BestPossibleHand || false;
			this.bonusPointsIncluded = lastRoll.ScoreBonusPointsIncluded || false;

			this.match = lastRoll.BestHand || false;
			this.rollsRemaining = 3 + hand.FreeRollsUsed - hand.Rolls.length;
			this.rollsRemaining = this.rollsRemaining > 0 ? this.rollsRemaining : 0;
			this.rolled = hand.Rolls.length > 0;
			this.complete = hand.State === 'co';
			this.rollNumber = hand.Rolls.length;
			this.score = hand.Score;
			this.finalScore = hand.FinalScore;
			this.bestHandTarget = hand.BestHandTarget;
			this.isWinner = (hand.Outcome === 1 || hand.Outcome === 3);
		}

		//console.log(toJS(this.dice));

	}

	@action adjustOpponentHand (hand) {
		this.handStrength = hand.HandStrength !== undefined ? hand.HandStrength : 0;
		this.match = this.diceFaces.map(v => 
			v === 'frown' ? false
			: getDiceFace(v)
		).filter(Boolean)
	}

	@observable bestHandTarget = 0;
	@observable handStrength = 0;

	@computed get bestHandTargetString(){
		return hands[this.bestHandTarget];
	}

	@observable dice = [];

	@observable rolling = false;
	@observable rolled = false;

	@observable rollsRemaining = 3;

	@observable rollNumber= 0;

	@observable best = false;
	@observable match = [];

	@observable complete = false;

	@observable score = 0;
	@observable finalScore = 0;

	@observable isWinner = false;

	// @computed get isWinner(){
	// 	return this.finalScore > this.score;
	// }

	@computed get isWinningHand() {
		return (this.match && this.match.length > 2);
	}

	@action ensureBestHandIsHeld(){
		if(this.match.length){
			this.dice.forEach((d, i) => {
				d.held = false;
				if(this.match.indexOf(i) > -1){
					d.held = true;
				}
			});
		}
	}

	@computed get heldIndexes(){
		var held = [];
		this.dice.forEach((d, i)=>{
			if(d.held){
				held.push(i);
			}
		});
		return held;
	}

	/* @computed get diceFaces(){
		return this.dice.map(d => d.showing);
	} */

	@computed get byValue(){
		return this.dice.map(d=>d.faces[d.showing][0]);
	}

	@computed get heldDiceCount(){
		return this.dice.filter(d => d.held).length;
	}

	@action roll(){
		if(this.complete){
			throw new Error('Attempt to roll a completed Hand. Dice can not be changed.');
		}
		return store.rollDice(this.heldIndexes)
		.then(response => {
			if(response && response.ErrorCode === 300019){
				setTimeout(() => {this.roll();},1000);
			}
		})
		.catch((err) => {
			let txt = 'hand.roll catch error:'+err;
			console.log(txt);
			// store.debug = txt + ' '+ store.debug;
		});
	}

	@action hold(index){
		var nextState = !this.dice[index].held;

		//validation
		if(store.activeMatch.currentHand.rollsRemaining < 1 || store.activeMatch.currentHand.best)
			return;

		// if(nextState && this.heldDiceCount > 7)
		// 	return;

		//tutorial checks for forced holds
		if(store.tutorialMode){
			if(store.tutorialState === 'allowroll' || store.tutorialState === 'handInfo'){
				return;
			}
			if(store.tutorialState === 'waitforjacks'){
				//if not approved dice or deselecting, early exit.
				if([0,8].indexOf(index) < 0 || !nextState){
					return;
				}
				if(this.heldDiceCount === 1){
					//total held will be 2 after this.
					store.tutorialState = 'allowroll';
					store.tutorialPreventRoll = false;
					store.m.ui.clearAvaPanel();
					store.m.diceHand.clearDarkenedUnlockedDice();
					store.m.cup.reallyReturnCup();
				}
			}
			if(store.tutorialState === 'waitforwild'){
				//if not approved dice or deselecting, early exit.
				if(index !== 1 || !nextState){
					return;
				}
				if(this.heldDiceCount === 2){
					//total held will be 3 after this.
					store.tutorialState = 'allowroll';
					store.tutorialPreventRoll = false;
					store.m.ui.clearAvaPanel();
					store.m.diceHand.clearDarkenedUnlockedDice();
					store.m.cup.reallyReturnCup();
				}
			}
			if(store.tutorialState === 'waitforking'){
				//if not approved dice or deselecting, early exit.
				if([3,5].indexOf(index) < 0 || !nextState){
					return;
				}
				if(this.heldDiceCount === 1){
					//total held will be 1 after this.
					store.tutorialState = 'allowroll';
					store.tutorialPreventRoll = false;
					store.m.ui.clearAvaPanel();
					store.m.diceHand.clearDarkenedUnlockedDice();
					store.m.cup.reallyReturnCup();
				}
			}
			let m = window.manager;
			if(store.tutorialState === 'waitforking2'){
				//if not approved dice or deselecting, early exit.
				if(index !== 3 && index !== 5 && index !== 1 && index !== 4)
					return;
				if((index === 3 || index === 5) && (!m.diceHand.dice[1].locked || !m.diceHand.dice[4].locked))
					return;
				if(index === 1 && m.diceHand.dice[1].locked)
					return;
				if(index === 4 && m.diceHand.dice[4].locked)
					return;
				if(index === 3 && !m.diceHand.dice[3].locked)
					return;
				if(index === 5 && !m.diceHand.dice[5].locked)
				return;

				var cloneDice = [...store.m.diceHand.dice];
				cloneDice[index].locked = nextState;
				if(cloneDice[1].locked && cloneDice[4].locked) {
					if(cloneDice[3].locked)
						m.diceHand.dice[3].addFlair('selectedYellowDot', store.settings.theme);
					if(cloneDice[5].locked)
						m.diceHand.dice[5].addFlair('selectedYellowDot', store.settings.theme);
					m.ui.createTutorialBox('skilz_tutorial_2_3', m.adjustY(852) * m.ui.avaPanelPos)
				}

				if(!cloneDice[3].locked && !cloneDice[5].locked && cloneDice[1].locked && cloneDice[4].locked) {
				// if([2,3].indexOf(index) < 0 && [1,7].indexOf(index) >= 0) {
				// if(this.heldDiceCount === 2){
					//total held will be 2 after this.
					store.tutorialState = 'allowroll';
					store.tutorialPreventRoll = false;
					store.m.ui.clearAvaPanel();
					store.m.diceHand.clearDarkenedUnlockedDice();
					store.m.cup.reallyReturnCup();
				}
			}
			if(store.tutorialState === 'waitforstraight'){
				//if not approved dice or deselecting, early exit.
				if([3,2,7,6,0].indexOf(index) < 0 || !nextState){
					return;
				}
				if(this.heldDiceCount === 4){
					//total held will be 5 after this.
					store.tutorialState = 'allowroll';
					store.tutorialPreventRoll = false;
					store.m.ui.clearAvaPanel();
					store.m.diceHand.clearDarkenedUnlockedDice();
					store.m.cup.reallyReturnCup();
				}
			}
			if(store.tutorialState === 'noflush'){
				return;
			}
			if(store.tutorialState === 'waitForJHKH'){
				//if not approved dice or deselecting, early exit.
				if([4,7].indexOf(index) < 0 || !nextState){
					return;
				}
				if(this.heldDiceCount === 1){
					//total held will be 1 after this.
					store.tutorialState = 'allowroll';
					store.tutorialPreventRoll = false;
					store.m.ui.clearAvaPanel();
					store.m.diceHand.clearDarkenedUnlockedDice();
					store.m.cup.reallyReturnCup();
				}
			}
			if(store.tutorialState === 'waitFor10H'){
				//if not approved dice or deselecting, early exit.
				if([4,7,0].indexOf(index) < 0 || !nextState){
					return;
				}
				if(this.heldDiceCount === 2){
					//total held will be 1 after this.
					store.tutorialState = 'allowroll';
					store.tutorialPreventRoll = false;
					store.m.ui.clearAvaPanel();
					store.m.diceHand.clearDarkenedUnlockedDice();
					store.m.cup.reallyReturnCup();
				}
			}
		} // end tutorial

		this.dice[index].held = nextState;
		return this.dice[index];
	}


	@action nextRoll(){
		this.rollsRemaining -= 1;
		this.rollNumber += 1;
		this.rolled = true;
	}

	@action updateFromNetwork(hand){
		this.complete = hand.State === 'co';
		this.score = hand.Score;
		this.finalScore = hand.FinalScore;
		this.isWinner = (hand.Outcome === 1 || hand.Outcome === 3);
		this.handStrength = hand.HandStrength !== undefined ? hand.HandStrength : 0;
	}

}
